import React from 'react';
import { Center, Text } from '@chakra-ui/react';

export const ServicesHeader = () => {
	return (
		<Center className='services-header'>
			<Text className='service-top'>SERVICES</Text>
		</Center>
	);
};
